import { render, staticRenderFns } from "./EmployerBase.vue?vue&type=template&id=1178c2d6&scoped=true&"
import script from "./EmployerBase.vue?vue&type=script&lang=js&"
export * from "./EmployerBase.vue?vue&type=script&lang=js&"
import style0 from "./EmployerBase.vue?vue&type=style&index=0&id=1178c2d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1178c2d6",
  null
  
)

export default component.exports